export const LOGG_UT_ARSAK = {
  Inaktivitet: 'inaktivitet',
  SesjonUtlopt: 'sesjon-utlopt',
} as const;

export default LOGG_UT_ARSAK;
